import Vue from "vue";
import _ from "lodash";

Vue.prototype.$_ = _;
// window._ = _;

export default _;
